import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HomeComponent } from './home/home.component';
import { PublicRoutingModule } from './public-routing.module';
import { PublicComponent } from './public.component';


import { TranslateModule } from '@ngx-translate/core';
import { ForbiddenComponent } from './Errors/forbidden/forbidden.component';
import { NotFoundComponent } from './Errors/not-found/not-found.component';
import { InternalServerErrorComponent } from './Errors/internal-server-error/internal-server-error.component';
import { BadRequestComponent } from './Errors/bad-request/bad-request.component';
import { UnauthorizedComponent } from './Errors/unauthorized/unauthorized.component';
import { SessionExpiredComponent } from './Errors/session-expired/session-expired.component';


import { DxChartModule, DxChartComponent, DxPieChartModule, DxRangeSelectorModule } from 'devextreme-angular';
//import { AffiliateRoutingModule } from '../affiliate/affiliate-routing.module';


import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';

import { HeaderComponent } from '../public/header/header.component';
import { SidebarComponent } from '../public/sidebar/sidebar.component';
import { MatPaginatorModule, MatNativeDateModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDatepickerModule } from '@angular/material';
import { MatExpansionModule } from '@angular/material/expansion';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { TokenChangePasswordComponent } from './token-change-password/token-change-password.component';

@NgModule({
    declarations: [

        HomeComponent,
        PublicComponent,
        ForbiddenComponent,
        NotFoundComponent,
        InternalServerErrorComponent,
        BadRequestComponent,
        UnauthorizedComponent,
        SessionExpiredComponent,
        HeaderComponent,
        SidebarComponent,
        TokenChangePasswordComponent
    ],
    imports: [
        AngularFontAwesomeModule,
        FormsModule,
        //BrowserAnimationsModule,
        NgxsReduxDevtoolsPluginModule.forRoot(),
        NgxsFormPluginModule.forRoot(),
        DxChartModule,
        DxPieChartModule,
        DxRangeSelectorModule,
        CommonModule,
        PublicRoutingModule,
        //AffiliateRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgbModule,
        DxChartModule, DxPieChartModule,
        MatPaginatorModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatExpansionModule
    ],
    exports: [
        HeaderComponent,
        SidebarComponent
    ]
})
export class PublicModule {


}
